import { Icon } from "@/components/ui/Icon";
import { duration, qty } from "@/lib/format";
import type { PodiumRow } from "@/lib/api/dashboard";
import "./dashboard.css";

/**
 * Xodimlar podiumi.
 *
 * Nega podium, oddiy jadval emas: bu bo'lim ombor rahbari uchun
 * emas, XODIMLAR uchun — panel smena boshida ekranda turadi va
 * natija ko'rinib turishi o'zi rag'bat beradi. Jadvalda bir xil
 * sonlar qatori bo'lardi.
 *
 * Faqat UCH o'rin: to'rtinchidan boshlab u podium emas, reyting
 * bo'lib qoladi va «eng yaxshi» tushunchasi yo'qoladi.
 *
 * Mezon — TOPSHIRIQ soni. Miqdor (`actual_qty`) birinchi bo'lsa,
 * bitta og'ir palletni ko'chirgan xodim kun bo'yi mayda terim
 * qilgandan o'tib ketardi.
 */

/** Podium bosqichlari: ikkinchi — chapda, birinchi — o'rtada. */
const ORDER = [1, 0, 2];

const PLACE_LABEL = ["1-o'rin", "2-o'rin", "3-o'rin"];

export function Podium({
  rows,
  names,
  loading,
}: {
  rows: PodiumRow[];
  names: Map<string, string>;
  loading?: boolean;
}) {
  if (loading) {
    return <div className="skeleton" style={{ height: 180 }} />;
  }

  if (rows.length === 0) {
    return (
      <p className="field-hint" style={{ margin: 0 }}>
        Bu davrda yakunlangan topshiriq yo'q — podium bo'sh.
      </p>
    );
  }

  return (
    <div className="podium">
      {ORDER.filter((place) => rows[place] !== undefined).map((place) => {
        const row = rows[place]!;
        // Ism topilmasa ID ko'rsatilmaydi: podiumda u hech narsa
        // anglatmaydi va xodim o'zini tanimaydi.
        const name = names.get(row.employee_id) ?? "Xodim";

        return (
          <div className={`podium-place podium-${place + 1}`} key={row.employee_id}>
            {/* Matn qismi TAYIN balandlikda: busiz kamomad qatori
                bor xodimning kartasi uzayib, ikkinchi o'rin
                birinchisidan baland ko'rinardi va podium
                shakli yo'qolardi. */}
            <div className="podium-body">
              <div className="podium-rank">{place + 1}</div>
              <div className="podium-name" title={PLACE_LABEL[place]}>
                {name}
              </div>
              <div className="podium-score num">{row.task_count}</div>
              <div className="podium-unit">topshiriq</div>
              <div className="podium-detail">
                {row.line_count} SKU · {qty(row.actual_qty)} dona
                <br />
                {duration(row.work_seconds)}
              </div>
              {/* Kamomad YASHIRILMAYDI: faqat tezlikni ko'rsatish
                  shoshilishni rag'batlantirardi, sifatni esa yo'q. */}
              {row.shortage_count > 0 && (
                <div className="podium-warn" title="Kamomad bilan yakunlangan topshiriqlar">
                  <Icon name="alert" size={12} />
                  {row.shortage_count} kamomad
                </div>
              )}
            </div>
            <div className="podium-step" aria-hidden="true" />
          </div>
        );
      })}
    </div>
  );
}
